/** 파일 확장자로 뷰어 종류를 정한다. */
export function detectFileKind(filename = '') {
    const ext = filename.split('.').pop().toLowerCase();
    if (ext === 'pdf') return 'pdf';
    if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') return 'xlsx';
    if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'avif'].includes(ext)) return 'image';
    return 'unknown';
}

let nextLineId = 1000;

/** 그리드 행 id를 붙여 초안 라인을 만든다. 행 추가 시에도 같은 규칙을 쓴다. */
export function newDraftLine(partial = {}) {
    nextLineId += 1;
    return {
        id: nextLineId,
        line_no: null,
        po_number: '',
        item_code: '',
        buyer_sku: '',
        style_name: '',
        barcode: '',
        description: '',
        description_alt: '',
        country_of_origin: '',
        qty: null,
        qty_uom: '',
        net_weight: null,
        gross_weight: null,
        volume: null,
        lot_no: '',
        production_date: null,
        expiry_date: null,
        cntr_hint: '',
        field_confidence: {},
        edited_fields: [],
        source_ref: null,
        ...partial,
    };
}
